// extracted by mini-css-extract-plugin
module.exports = {"mask":"Image_mask__3qRxq","loading":"Image_loading__10DCF"};